// footer-social-icon popup
let myPopup = document.querySelector(".main-custom-popup-container");
let social_icon = document.querySelectorAll(".list-social__item");
const overflow = document.querySelector('footer .overflow');

social_icon.forEach((icon) => {
  icon.addEventListener('click', () => {
    let social_links = icon.getAttribute("socialLink"); // corrected
    document.querySelector('.proceed-btn a').href = social_links;
    myPopup.classList.add("active");
    overflow.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  });
});

const close_btn = document.querySelector('.main-custom-popup-container .inner-second-div');
if(close_btn) {
  close_btn.addEventListener('click', () => {
    console.log('close_btn',close_btn)
    close_btn.closest('.main-custom-popup-container').classList.remove('active');
    overflow.classList.add('hidden');
    document.body.style.overflow = 'auto';
  })
}

const cancel_btn = document.querySelector('.main-custom-popup-container .cancel-btn');
if(cancel_btn) {
  cancel_btn.addEventListener('click', () => {
    console.log('cancel_btn',cancel_btn)
    cancel_btn.closest('.main-custom-popup-container').classList.remove('active');
    overflow.classList.add('hidden');
    document.body.style.overflow = 'auto';
  })
}


// footer-social-icon-popup-end


document.querySelector(".cstm_cart").addEventListener("click",()=>{
  let drawercart=document.querySelector("drawer");
 console.log("drawercart",drawercart)
})

// document.addEventListener("DOMContentLoaded", () => {
//   if (window.matchMedia("(max-width: 760px)").matches) {
//     document.querySelector(".cstm_cart").addEventListener("click", () => {
//       window.location.href = "https://engageshopitc.myshopify.com/cart";
//     });
//   }
// });

document.addEventListener("click", function (e) {
  //alert();
  if (window.innerWidth < 750 && e.target.closest("#cart-icon-bubble")) {
    window.location.href = "/cart";
  }
});


// Discount Code functionality Saumya
if(window.location.pathname == '/cart'){
  document.addEventListener('DOMContentLoaded', async function(){
    let discountCode = 0;
    const old_cartDrawer__footer = document.querySelector('.cart-drawer__footer');
    const mainCart__footer = document.querySelector('#main-cart-footer');
    var old_discount_html = document.querySelector('.discount_code_container');
    var popup_remove_btn_disc = document.querySelector('.input_coupon_container .model_footer .remove_discount_btn');
    const coupon_error_message = document.querySelector('.coupon_error');
    // showDiscountCode();
    document.body.addEventListener('click', (e) => {
      const button = e.target.closest('.discount_code_container button');
      const targetClass = e.target.classList;
      if (button) {
        const discountCode = document.querySelector('.discount_code_container .inputValue__discount').value.toLowerCase();
        button.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0650/7986/9645/files/Rolling_1x-0.8s-35px-35px.gif?v=1743569135" alt="Loading..." style="height: 20px; width: 20px;">`;
        if (button.classList.contains('apply_code')) {
          console.log('discountCode',discountCode);
          applyDiscount(discountCode);
        } else {
          removeDiscount();
        }
      }
      else if(targetClass.value == 'view_coupon_code'){
        // updatePopup_btn();
       document.querySelector('.input_coupon_container').classList.toggle('hidden');
       document.querySelector('.overlay_coupon').classList.toggle('hidden');
        // if (document.querySelector('.discount_code_container .apply_code')){
        //     popup_remove_btn_disc.classList.add('hidden');
        //     popup_remove_btn_disc.previousElementSibling.classList.remove('hidden');
        // } else {
        //     popup_remove_btn_disc.classList.remove('hidden');
        //     popup_remove_btn_disc.previousElementSibling.classList.add('hidden');
        // }
      }
      else if(targetClass.value == 'copy_coupon_code'){
        var clipboardText = document.querySelector(".clipboard_text");
        // console.log('targetClass', e.target.attributes.code_title.value);
        navigator.clipboard.writeText(e.target.attributes.code_title.value);
        clipboardText.textContent = `${e.target.attributes.code_title.value} Copied`;
        clipboardText.classList.remove('hidden');
        setTimeout(function(){
          clipboardText.classList.add('hidden');
        }, 2000);
      }
      else if(targetClass.value == 'checkbox_popup_disc'){
        // console.log('targetClass', e.target)
        if(e.target.checked == true){
          document.querySelector('.model_body .input_form input').value = e.target.value;
        }else{
          document.querySelector('.model_body .input_form input').value = '';
        }
      }
      else if(targetClass.value == 'apply_discount_btn' || targetClass.value == 'check_discount_code'){
        const popupInput_value = e.target.closest('.input_coupon_container').querySelector('.model_body .input_form input').value.toLowerCase();
        if (popupInput_value !== '' && /^[a-zA-Z0-9]+$/.test(popupInput_value)){
          applyDiscount(popupInput_value);
          e.target.closest('.input_coupon_container').classList.add('hidden');
           document.querySelector('.overlay_coupon').classList.add('hidden');
        }else{
          const blankValue_error = document.querySelector('.input_coupon_container .model_body .error_empty_discount');
          blankValue_error.classList.remove('hidden');
          setTimeout(function(){
            blankValue_error.classList.add('hidden');
          }, 4000);
        }
      }
      else if(targetClass.value == 'remove_discount_btn'){
        document.querySelector('.discount_code_container button').click();
        e.target.previousElementSibling.disabled = false;
        e.target.closest('.input_coupon_container').querySelector('.close_container').click();
      }
      else if(targetClass.value == 'close_container'){
        e.target.closest('.input_coupon_container').classList.add('hidden');
        document.querySelector('.overlay_coupon').classList.add('hidden');
      }
    });
    
  //   async function showDiscountCode(){
  //     const listDiscount = document.querySelector('.model_body .coupon_code_list');  
  //     try{
  //       const requestOptions = {
  //         method: "POST",
  //         redirect: "follow"
  //       };
        
  //       const response = await fetch("https://hul-services.enscommerce.in/engage/discount/get", requestOptions);
  //       const result = await response.json();
  //         listDiscount.innerHTML = result.discount.map(code => {
  //           const {type, title, description} = code;
  //           const isAutomatic = type.toLowerCase() === 'automatic';
  //           return isAutomatic
  //             ?`<li>
  //               <label class="discount_title">${title}</label>
  //               <span>${description}</span>
  //             </li>
  //             `:`
  //             <li>
  //               <input type="checkbox" class="checkbox_popup_disc" value="${title}" />
  //               <label class="discount_title">${title}</label>
  //               <span>${description}</span>
  //             </li>
  //             `
  //         }).join('');
  //       }
  //       catch(error){
  //         console.log('ERROR', error);
  //       }
  // }
  
    async function renderCartPageFooter(){
      try {
        const response = await fetch(`${window.location.href}?section_id=main-cart-footer`);
        const responseText = await response.text();
        return new DOMParser().parseFromString(responseText, 'text/html');
      } catch (error) {
        console.error('Error fetching cart data:', error);
        return '';
      }
    }
  
    async function renderMainCartItems(){
      try {
        const response = await fetch(`${window.location.href}?section_id=main-cart-items`);
        const responseText = await response.text();
        return new DOMParser().parseFromString(responseText, 'text/html');
      } catch (error) {
        console.error('Error fetching cart data:', error);
        return '';
      }
    }
    
    async function applyDiscount(discountCode){
        // const requestOptions = {
        //   method: "POST",
        //   redirect: "follow"
        // };
      // const response = await fetch("https://hul-services.enscommerce.in/engage/discount/get", requestOptions);
    
      try {
        // if (!response.ok) {
        //   throw new Error(`Error: ${response.status}`);
        // }
        // const result = await response.json();
        // let is_valid_coupon = result.discount.some((item) => item.title.toLowerCase() === discountCode);
    
        // if (!is_valid_coupon) {
        //   const errorMessage = document.querySelector('.cstm-cart-page .coupon_error');
        //   errorMessage.classList.remove('hidden');
        //   window.scrollTo({ top: 0, behavior: "smooth" });
        //   if(!errorMessage.classList.contains('hidden')){
        //     setTimeout(function(){
        //       errorMessage.classList.add('hidden');
        //       document.querySelector('.discount_code_container button').textContent = 'Use Coupon Code';
        //     }, 4000);
        //   }
        //   return;
        // } else {
          let tgt_discount_res = await fetch(`/discount/${discountCode}`);
  console.log('tgt_discount_res', tgt_discount_res.ok)
          if (tgt_discount_res.ok) {
              // updatePopup_btn();
            renderMainCartItems().then((item) => {
              document.querySelector('.cstm-cart-page .cart-page-container').innerHTML = item.querySelector('#shopify-section-main-cart-items .cstm-cart-page .cart-page-container').innerHTML;
            });
          }else{
            coupon_error_message.classList.remove('hidden');
          }
        // }
      } catch (error) {
        console.error('Failed to fetch price rules:', error);
      }
    }
  
    async function removeDiscount(){
      let tgt_discount_res = await fetch(`/discount/remove`);
  
      if (tgt_discount_res.ok) {
        sessionStorage.setItem('discountremove', 'true');
        // updatePopup_btn();
        renderMainCartItems().then((item) => {
          document.querySelector('.cstm-cart-page .cart-page-container').innerHTML = item.querySelector('#shopify-section-main-cart-items .cstm-cart-page .cart-page-container').innerHTML;
        });
      }
    }
  
    // function updatePopup_btn(){
    //   var popup_remove_btn_disc = document.querySelector('.input_coupon_container .model_footer .remove_discount_btn');
    //   if(popup_remove_btn_disc.classList.contains('hidden')){
    //     popup_remove_btn_disc.classList.remove('hidden');
    //     popup_remove_btn_disc.previousElementSibling.classList.add('hidden');
    //   }else{
    //     popup_remove_btn_disc.classList.add('hidden');
    //     popup_remove_btn_disc.previousElementSibling.classList.remove('hidden');
    //   }
    // }
  });
}

/*----search input placeholder auto print code starts----*/
document.addEventListener("DOMContentLoaded", function() {
  const searchInputs = document.querySelectorAll(".cstm_search_input_placeholder"); // Select all matching inputs
  const searchPhrases = [
    "Search for Deodorants", 
    "Search for perfumes", 
    "Search for colognes", 
    "Search for fine fragrances", 
    "Search for EAU DE Parfum", 
    "Search for Gift Box"
  ];
  let index = 0; // Tracks which phrase is currently being typed
  let charIndex = 0; // Tracks character position within the phrase
  let isDeleting = false; // Flag to control typing or deleting
  function updatePlaceholders() {
    let currentPhrase = searchPhrases[index];
    searchInputs.forEach(input => {
      if (!isDeleting) {
        // Typing forward
        input.placeholder = currentPhrase.substring(0, charIndex + 1);
      } else {
        // Deleting in reverse
        input.placeholder = currentPhrase.substring(0, charIndex - 1);
      }
    });
    if (!isDeleting) {
      charIndex++;
      if (charIndex === currentPhrase.length) {
        isDeleting = true; // Start deleting after full phrase is printed
        setTimeout(updatePlaceholders, 1000); // Pause before deleting
        return;
      }
    } else {
      charIndex--;
      if (charIndex === 0) {
        isDeleting = false; // Start typing next phrase
        index = (index + 1) % searchPhrases.length; // Loop back to first phrase
        setTimeout(updatePlaceholders, 500); // Small pause before typing new phrase
        return;
      }
    }
    setTimeout(updatePlaceholders, 100); // Speed of typing/deleting
  }
  updatePlaceholders(); // Start the animation
});
/*----search input placeholder auto print code starts----*/